import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@Components/Button';
import DateRangePicker from '@Components/DateRangePicker';
import GroupsLayoutProps from '@Components/GroupsLayout/GroupsLayout.types';
import MainSectionLayout from '@Components/MainSectionLayout';
import SearchBar from '@Components/SearchBar';

const GroupsLayout: FunctionComponent<GroupsLayoutProps> = (
  props: GroupsLayoutProps
): JSX.Element => {
  const {
    isAdmin,
    searchProps,
    dateRangeProps,
    heading,
    showFilterControls,
    selectedBtnNumber,
    selectedBtnProps,
    cancelBtnProps,
    deleteBtnProps,
    clearFilterBtnProps,
    groupsAddBtnProps,
    ...resProps
  } = props;

  const { t } = useTranslation();

  const headingText = t('groups.Groups');
  const filtersComponent = (
    <>
      <Box
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        gap={1.6}
        mb={1.6}
      >
        <SearchBar {...searchProps} maxWidth={33.3} />
        <Box minWidth="25.6rem">
          <DateRangePicker {...dateRangeProps} />
        </Box>
        <Button
          color="primary"
          icon="add"
          text={t('groups.Add Group')}
          sx={{ ml: 'auto' }}
          {...groupsAddBtnProps}
        />
      </Box>
      {!!selectedBtnNumber && (
        <Box display="inline-flex" alignItems="center" gap={0.8}>
          <Button
            variant="text"
            color="inherit"
            icon="checkboxFilled"
            iconColor="primary"
            text={`${selectedBtnNumber || 0} ${t('common.messages.Selected')}`}
            sx={{ textTransform: 'none' }}
            {...selectedBtnProps}
          />
          <Button
            variant="text"
            color="inherit"
            icon="delete"
            text={t('common.messages.Delete')}
            sx={{ textTransform: 'none' }}
            {...deleteBtnProps}
          />
          <Button
            variant="text"
            color="secondary"
            text={t('common.messages.Cancel')}
            {...cancelBtnProps}
          />
        </Box>
      )}
    </>
  );

  return (
    <MainSectionLayout
      heading={headingText}
      filters={filtersComponent}
      {...resProps}
    />
  );
};

export default GroupsLayout;
